import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCommunity } from '../contexts/CommunityContext';

const HiddenPosts = () => {
  const { t } = useTranslation();
  const { getHiddenPosts, restorePost, getReports } = useCommunity();

  const [hiddenPosts, setHiddenPosts] = useState([]);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadHiddenPosts();
  }, []);

  const loadHiddenPosts = () => {
    try {
      const hidden = getHiddenPosts();
      setHiddenPosts(hidden || []);
    } catch (err) {
      console.error('Failed to load hidden posts');
    }
  };

  const handleRestorePost = (postId) => {
    try {
      restorePost(postId, true);
      setMessage(t('admin.moderation.success.restored'));
      loadHiddenPosts();
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage(t('admin.moderation.error.restoreFailed'));
    }
  };

  return (
    <div className="p-6">
      {message && (
        <div className={`py-4 px-5 rounded-lg mb-6 text-sm font-medium flex items-center gap-2.5 ${
          message.includes('error') || message.includes('실패')
            ? 'bg-red-50 text-red-600 border border-red-200'
            : 'bg-green-50 text-green-600 border border-green-200'
        }`}>
          {message}
        </div>
      )}

      <div className="mb-8">
        <h2 className="text-base font-bold mb-3.5 text-[#1d1d1f] tracking-tight pb-2.5 border-b border-gray-200">
          {t('admin.moderation.hiddenPosts')}
        </h2>
        {hiddenPosts.length === 0 ? (
          <p className="text-center text-gray-400 py-12 px-6 bg-neutral-50 rounded-xl text-[15px]">
            숨겨진 게시글이 없습니다.
          </p>
        ) : (
          <div className="flex flex-col gap-3">
            {hiddenPosts.map((post) => (
              <div key={post.id} className="bg-neutral-50 border border-gray-200 rounded-lg py-4 px-5 flex justify-between items-center max-md:flex-col max-md:gap-3 max-md:items-start">
                <div className="flex flex-col gap-1">
                  <strong className="text-[#1d1d1f] text-[15px]">{post.title}</strong>
                  <span className="text-[13px] text-gray-600">{post.author?.name}</span>
                  <span className="text-[13px] text-gray-600">{t('admin.moderation.reportCount')}: {post.reportCount}</span>
                </div>
                <button
                  onClick={() => handleRestorePost(post.id)}
                  className="py-2.5 px-4 bg-blue-50 text-blue-600 border-none rounded-md text-[13px] font-semibold cursor-pointer transition-all hover:bg-blue-100"
                >
                  {t('admin.moderation.actions.restore')}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HiddenPosts;
